import { fetchRobo } from '@ratehub/inv-common';

import { Products } from '../definitions/Products';
import enrichDepositsProduct from './enrichDepositsProduct';


function enrichProduct(cmsEntry, apiEntry, slot) {
    // Enrich common fields with other deposits
    enrichDepositsProduct(cmsEntry, apiEntry, slot);

    Object.assign(slot, {
        productType: Products.ROBO_ADVISORS,
    });
}

export default async function enrichRoboProducts(slots, options) {
    const response = await fetchRobo({
        products: slots.map(({ requested }) => ({
            requested: requested.map(product => ({
                id: product.id,
            })),
            fallback: { },
        })),
        ...options,
    });

    // Support new and legacy return shape
    const products = response.data?.products ?? response.data;

    slots.forEach((slot, index) => {
        let matchedRate;

        for (let i = 0; i < slot.requested.length; i++) {
            const roboAdvisor = slot.requested[i];
            matchedRate = products.find(
                product => product?.id === roboAdvisor.id
            );

            // Rates are not always featured, so a matched rate is not guaranteed
            if (matchedRate) {
                enrichProduct(roboAdvisor, matchedRate, slot);
                // We only need to enrich the first product we come across.
                break;
            }
        }

        // If no matchedRate is found, use fallback
        if (!matchedRate) {
            const fallbackRate = products[index];

            if (fallbackRate) {
                enrichProduct(slot.fallback, fallbackRate, slot);
            }
        }
    });
}
